module.exports = __webpack_public_path__ + "LI.png?b568bc0872956205d1011b1d302143c2";